<template>
  <div class="index-box indexBox-Backgroud">
    <img :src="btnDingbubeijing" class="almaMaterDingbubeijing" />
    <img :src="btnLogo" class="almaMaterbtnLogo" />
    <div class="card">
      <div class="volume-wrapper">
        <div
          class="volume-item"
          v-for="icon in titleArray"
          :key="icon.inex"
          @click="jumpPage(icon)"
        >
          <van-icon :name="icon.icon" size="3rem" />
          <span>{{ icon.title }}</span>
        </div>
      </div>
    </div>
    <!-- 母校人物 -->
    <div class="listBox ontList" v-if="characterAlumni.length > 0">
      <div class="FirstLevelTitle leftShift">
        <div>母校人物</div>
        <div @click="dynamicJump">更多</div>
      </div>
      <div class="activeDetailsDiv">
        <div class="clearfix">
          <div class="alumnlistBox">
            <div
              class="RepresentativeListCard"
              v-for="(item, index) in characterAlumni"
              :key="index"
              @click="gotoAlumni(item)"
            >
              <div class="card-list__itemone">
                <img class="headDiagram" :src="item.imgPath" />
              </div>
              <div class="card-list__itemtwo">
                <span class="DynamicTitle">{{ item.personName }}</span>
                <span class="DynamicTitle-x">{{ item.post }}</span>
                <span class="DynamicDate ellipsis-multiline">{{
                  item.jianjie
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 电子期刊 -->
    <div
      :class="characterAlumni.length > 0 ? 'listBox' : 'listBox ontList'"
      v-if="false"
    >
    <!-- v-if="journal.length > 0" -->
      <div class="FirstLevelTitle leftShift">
        <div>电子期刊</div>
        <div @click="journalJump">更多</div>
      </div>
      <div
        class="journalListCard"
        v-for="(item, index) in journal"
        :key="index"
        @click="journaldetail(item)"
      >
        <div class="card-list__itemone">
          <img class="headDiagram" :src="item.img" />
        </div>
        <div class="card-list__itemtwo">
          <span class="DynamicTitle">{{ item.name }}</span>
          <span class="DynamicTitle-x"
            >{{ item.year }}年第{{ item.number }}期</span
          >
          <span class="DynamicDate">{{ item.updateTime.slice(0, 10) }}</span>
        </div>
      </div>
    </div>

    <!-- 母校映像 -->
    <div
      :class="
        characterAlumni.length > 0 || journal.length > 0
          ? 'listBox'
          : 'listBox ontList'
      "
      v-if="imageVideo.length > 0 || imageImg.length > 0"
    >
      <div class="FirstLevelTitle leftShift">
        <div>母校映像</div>
        <div @click="imageJump">更多</div>
      </div>

      <div
        class="imageListCard"
        v-for="(item, index) in imageVideo"
        :key="index"
      >
        <div class="card-list__itemone">
          <video
            class="headDiagram"
            :ref="`video${index}`"
            controls
            :poster="item.mainImage"
          >
            <source :src="item.video" type="video/mp4" />
          </video>
        </div>
      </div>
      <div class="imageListCard" v-for="item in imageImg" :key="item.index">
        <div class="card-list__itemone">
          <img class="headDiagram" :src="item.img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, Toast } from "vant";
import download from "@/utils/download";
import btnDingbubeijing from "@/assets/image/almaMater/btn_dingbubeijing_nor.png";
import btnLogo from "@/assets/image/almaMater/btn_logo_nor.png";
import btnJianjie from "@/assets/image/almaMater/btn_jianjie_nor.png";
import btnLingdao from "@/assets/image/almaMater/btn_lingdao_nor.png";
import btnZhangcheng from "@/assets/image/almaMater/btn_zhangcheng_nor.png";
import btnLishi from "@/assets/image/almaMater/btn_lishi_nor.png";
import btnMuxiaorenwu from "@/assets/image/almaMater/btn_muxiaorenwu_nor.png";
import btnXuexiaobiaoshi from "@/assets/image/almaMater/btn_xuexiaobiaoshi_nor.png";
import btnDitu from "@/assets/image/almaMater/btn_ditu_nor.png";
import btnQita from "@/assets/image/almaMater/btn_qita_nor.png";

const titleArray = Object.freeze([
  {
    icon: btnJianjie,
    title: "学校简介",
    index: 1,
    url: "/schoolHistory",
  },
  {
    icon: btnLingdao,
    title: "现任领导",
    index: 2,
    url: "/currentLeader",
  },
  {
    icon: btnZhangcheng,
    title: "学校章程",
    index: 3,
    url: "/constitution",
  },
  {
    icon: btnLishi,
    title: "学校历史",
    index: 4,
    url: "/historicalIntroduction",
  },
  {
    icon: btnMuxiaorenwu,
    title: "母校人物",
    index: 5,
    url: "/character",
  },
  {
    icon: btnXuexiaobiaoshi,
    title: "学校标识",
    index: 6,
    url: "/identification",
  },
  {
    icon: btnDitu,
    title: "校园地图",
    index: 7,
    url: "/campus",
  },
  {
    icon: btnQita,
    title: "其他",
    index: 8,
    url: "/",
  },
  // {
  //   icon: btnXiaoqihezuo,
  //   title: "合作交流",
  //   index: 5,
  //   url: "/schoolRrunEnterprise",
  // },
]);

export default {
  data() {
    return {
      btnDingbubeijing,
      btnLogo,
      btnJianjie,
      btnLingdao,
      btnZhangcheng,
      btnLishi,
      btnMuxiaorenwu,
      btnXuexiaobiaoshi,
      btnDitu,
      btnQita,
      titleArray,
      // 母校人物
      characterAlumni: [],
      // 电子期刊
      journal: [],
      // 母校映像--视频&&图片
      imageVideo: [],
      imageImg: [],
      id: "",
    };
  },
  created() {
    this.getCharacterAlumni();
    this.getJournal();
    this.getImageVideo();
    this.getImageImg();
  },

  methods: {
    async jumpPage(icon) {
      if (icon.index == "8") {
        this.$toast("开发中，敬请期待！");
      } else {
        return this.$router.push(icon.url);
      }
    },

    // 获取母校动态
    async getCharacterAlumni() {
      const result = await this.$http.get("/amPerson/getExAlumniByPage", {
        params: { currentPage: 1, perPage: 5 },
      });
      console.log("母校人物", result.data.list);
      if (result.data.list.length > 4) {
        this.characterAlumni = result.data.list.slice(0, 4);
      } else {
        this.characterAlumni = result.data.list;
      }
    },
    // 获取电子期刊
    async getJournal() {
      const result = await this.$http.get("/amJournal/getJournal");
      console.log("获取电子期刊", result.data);
      if (result.data.length > 2) {
        this.journal = result.data.slice(0, 2);
      } else {
        this.journal = result.data;
      }
    },
    // 获取母校映像--视频
    async getImageVideo() {
      const result = await this.$http.get("/amImage/getAllImage");
      console.log("获取母校映像", result.data);
      if (result.data.length > 2) {
        this.imageVideo = result.data.slice(0, 2);
      } else {
        this.imageVideo = result.data;
      }
    },
    // 获取母校映像--图片
    async getImageImg() {
      const result = await this.$http.get("/amStylePhoto/getStylePhotoCover", {
        params: { typeId: "-1" },
      });
      console.log("获取母校映像-图片", result.data);

      if (result.data.length > 2) {
        this.imageImg = result.data.slice(0, 2);
      } else {
        this.imageImg = result.data;
      }
    },

    dynamicJump() {
      return this.$router.push("/character");
    },
    journalJump() {
      return this.$router.push("/journal");
    },
    journaldetail(item) {
      this.id = item.id;
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否进行下载文件？",
        })
        .then(() => {
          this.downPdf();
        })
        .catch(() => {
          // on cancel
        });
    },

    // 获取电子期刊详情文件
    async downPdf() {
      const result = await this.$http.get("amJournal/getJournalById", {
        params: { id: "1" },
      });
      download(result.data);
      console.log("获取电子期刊详情文件", result.data);
    },

    // 获取母校映像--图片
    imageJump() {
      return this.$router.push("/clip");
    },
    // gotoDynamicDetail(item) {
    //   // return window.location.href = "https://www.sie.edu.cn/index/xxyw.htm";
    //   return this.$router.push({
    //     path: "/dynamicDetails",
    //     query: {
    //       id: item.id,
    //     },
    //   });
    // },
    gotoAlumni(item) {
      return this.$router.push({
        path: "/CharacterAlumniDetails",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  // image-rendering: -webkit-optimize-contrast;
  .almaMaterDingbubeijing {
    position: relative;
    top: 0vh;
    left: 0;
    width: 100%;
    height: 25vh;
    object-fit: cover;
  }
  .almaMaterbtnLogo {
    position: absolute;
    display: flex;
    top: 1vh;
    // width: 30vw;
    left: 33.3vw;
    object-fit: cover;
    // image-rendering: -moz-crisp-edges;
    // image-rendering: -o-crisp-edges;
    // image-rendering: -webkit-optimize-contrast;
    // image-rendering: crisp-edges;
    // -ms-interpolation-mode: nearest-neighbor;
    z-index: 2;
  }
  .card {
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: 6vh;
    left: 5vw;
    width: 90vw;
    height: 29.5vh;
    background: #fff;
    border-radius: 1rem;
    z-index: 1;
    padding-bottom: 15px;
    object-fit: cover;
    .volume-wrapper {
      display: flex; /* flex布局 */
      flex-direction: row;
      justify-content: flex-start; /* 左对齐 */
      flex-wrap: wrap; /* 换行 */
      margin-top: 100px;
      height: 9vh;
    }

    .volume-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 2.5px 2.5px 2.5px 2.5px;
      width: calc((90vw - 30px) / 4);

    }

    .volume-item :nth-child(2) {
      font-size: 0.95rem;
      margin-top: -10px;
    }
  }

  .listBox {
    width: 100vw;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    // border: 1px solid #000;
    box-sizing: border-box;
    .listTitleBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 90vw;
      margin-left: 5vw;
      .identification {
        width: 5px;
        height: 18px;
        background: #00706e;
        margin-right: 5px;
      }
      .listTitle {
        font-size: 1.2rem;
        color: #000;
        font-weight: 600;
        width: 80vw;
      }
      .more {
        width: calc(100vw - (80vw - 5px));
        text-align: right;
        color: #00706e;
        margin-top: 3px;
      }
    }
    .listCard {
      display: flex;
      width: 90vw;
      background: #fff;
      border-radius: 0.5rem;
      height: 7rem;
      margin-left: 5vw;
      margin-top: 10px;

      .card-list__itemone {
        flex: 1;
        width: 30vw;
        margin: 5px 0 5px 0;
        margin-left: 5px;
        .active-list__item-location {
          position: relative;
          top: -1px;
          left: -1px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 5.03rem;
          height: 1.79rem;
          font-size: 0.99rem;
          color: #ffffff;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 15px;
          background: #00706e;
          background-size: contain;
          z-index: 2;
        }
        .active-list__item-location-y {
          position: relative;
          top: -1px;
          left: -1px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 5.03rem;
          height: 1.79rem;
          font-size: 0.99rem;
          color: #ffffff;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 15px;
          background: #f79d27;
          background-size: contain;
          z-index: 2;
        }

        .headDiagram {
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: 5px;
          top: -1.79rem;
          z-index: 0;
          //     image-rendering: -moz-crisp-edges;
          //  image-rendering: -o-crisp-edges;
        }
      }
      .card-list__itemtwo {
        flex: 2;
        margin: 5px 3px 5px 5px;
        display: flex;
        flex-direction: column;
        // border: 1px solid  #c02424;
        // height: 30px;
        // max-height:40px;

        .DynamicTitle {
          // position: relative;
          padding: 5px 5px 0 5px;
          font-size: 15px;
          font-weight: 600;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .DynamicDate {
          position: absolute;
          padding-left: 5px;
          font-size: 12px;
          color: #a0a0a0;
          margin-top: 5rem;
        }
      }
    }

    .journalListCard {
      display: flex;
      width: 90vw;
      background: #fff;
      border-radius: 0.5rem;
      // height: 10rem;
      margin-left: 5vw;
      margin-top: 10px;

      .card-list__itemone {
        flex: 1;
        width: 25vw;
        margin: 5px 0 5px 0;
        margin-left: 5px;
        // background: #00706e;
        .headDiagram {
          // width: 100%;
          // height: 100%;
          z-index: 0;
          // image-rendering: -moz-crisp-edges;
          // image-rendering: -o-crisp-edges;
          // image-rendering: -webkit-optimize-contrast;
          // image-rendering: crisp-edges;
          // -ms-interpolation-mode: nearest-neighbor;
        }
      }
      .card-list__itemtwo {
        flex: 2;
        margin: 5px 3px 5px 0px;
        display: flex;
        flex-direction: column;
        .DynamicTitle {
          width: 63vw;
          position: relative;
          margin: 5px 5px 0 5px;
          font-size: 1rem;
          // background: #a9a9a9;
          font-weight: 600;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .DynamicTitle-x {
          position: relative;
          margin: 5px 5px 0 5px;
          font-size: 0.9rem;
          // font-weight: 500;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .DynamicDate {
          margin-top: 50px;
          padding-left: 5px;
          font-size: 0.8rem;
          color: #a0a0a0;
        }
      }
    }

    .imageListCard {
      display: flex;
      width: 90vw;
      border-radius: 0.5rem;
      height: 13rem;
      margin-left: 5vw;
      margin-top: 10px;
      border: 1px solid #e6e6e6;
      border-radius: 10px;

      .card-list__itemone {
        flex: 1;
        border-radius: 10px;
        .headDiagram {
          width: 90vw;
          height: 13rem;
          border-radius: 10px;
          object-fit: cover;
          image-rendering: -webkit-optimize-contrast;
        }
      }
    }
  }
  .ontList {
    margin-top: 115px;
  }

  .activeDetailsDiv {
    padding-top: 5px;
    width: 88vw;
    margin-left: 2.5vw;
    padding-right: 20px;
    overflow-x: scroll;
    overflow-y: hidden;
  }

  .activeDetailsDiv::-webkit-scrollbar {
    display: none;
  }

  .clearfix:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clearfix {
    *zoom: 1;
    width: 150px;
  }

  .clearfix-fh:after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .clearfix-fh {
    *zoom: 1;
  }

  .alumnlistBox {
    // position: relative;
    // width: 80vw;
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    .RepresentativeListCard {
      display: flex;
      width: 85vw;
      background: #fff;
      border-radius: 0.5rem;
      height: 11rem;
      margin-left: 2.5vw;
      margin-top: 10px;
      .card-list__itemone {
        flex: 1;
        width: 35vw;
        margin: 5px 0 5px 5px;
        // margin-left: 5px;
        // border: 1px solid #181616;
        .headDiagram {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 0;
          border-radius: 10px;
          background-size: 100% 100%;
          image-rendering: -webkit-optimize-contrast;
        }
      }
      .card-list__itemtwo {
        flex: 2;
        width: 40vw;
        margin: 0px 3px 5px 5px;
        display: flex;
        flex-direction: column;
        .DynamicTitle {
          position: relative;
          margin: 5px 5px 0 5px;
          font-size: 1.1rem;
          font-weight: 600;
        }

        .DynamicTitle-x {
          position: relative;
          margin: 5px 5px 0 5px;
          font-size: 1rem;
          color: #727272;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .DynamicDate {
          margin-top: 5px;
          padding: 0 10px 0 5px;
          font-size: 0.85rem;
          color: #a9a9a9;
          line-height: 20px;
          text-align: justify;
        }
        .ellipsis-multiline {
          line-height: 25px; //行间距
          // text-indent: 4ch;//首行缩进
          text-align: justify; //两端对齐
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/AlumniHome.vue